import { render, staticRenderFns } from "./Precent.vue?vue&type=template&id=ff7f7c78&"
import script from "./Precent.vue?vue&type=script&lang=js&"
export * from "./Precent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/zklink/web/zklink-explorer-web-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff7f7c78')) {
      api.createRecord('ff7f7c78', component.options)
    } else {
      api.reload('ff7f7c78', component.options)
    }
    module.hot.accept("./Precent.vue?vue&type=template&id=ff7f7c78&", function () {
      api.rerender('ff7f7c78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/componentsG/Precent.vue"
export default component.exports